export const environment = {
  production: true,
  useStorage: true,
};
